/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LobbyImageModelSearchResultModel } from '../../models/lobby-image-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface LobbyIdImagesPost$Params {
  id: string;
      body?: SearchRequestModel
}

export function lobbyIdImagesPost(http: HttpClient, rootUrl: string, params: LobbyIdImagesPost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<LobbyImageModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, lobbyIdImagesPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<LobbyImageModelSearchResultModel>;
    })
  );
}

lobbyIdImagesPost.PATH = '/Lobby/{id}/Images';
